import axios from 'axios';

import {
    PlaceApiStatus,
    type PlaceAutocompleteResponse,
    type PlaceDetailsResponse,
} from '../../shared/googlePlaces';
import { type Locale } from '../../shared/locale';

const getLanguageFromLocale = (locale: string): Locale => {
    return locale.split('-')[0] as Locale;
};

type FetchPlacesSuggestionsParams = {
    input: string;
    sessionToken: string;
    locale: string;
};

const fetchPlacesSuggestions = async ({
    input,
    sessionToken,
    locale,
}: FetchPlacesSuggestionsParams): Promise<PlaceAutocompleteResponse> => {
    let result;
    try {
        result = await axios.get<PlaceAutocompleteResponse>('/api/places/suggestion', {
            params: {
                input,
                sessionToken,
                language: getLanguageFromLocale(locale),
            },
        });
    } catch {
        throw new Error(PlaceApiStatus.TECH_ERROR);
    }

    if (result.data.status === PlaceApiStatus.ZERO_RESULTS) {
        throw new Error(PlaceApiStatus.ZERO_RESULTS);
    }

    if (result.data.status !== PlaceApiStatus.OK) {
        throw new Error(PlaceApiStatus.TECH_ERROR);
    }

    return result.data;
};

type FetchPlacesDetailParams = {
    placeId: string;
    sessionToken: string;
    locale: string;
};

const fetchPlacesDetail = async ({
    placeId,
    sessionToken,
    locale,
}: FetchPlacesDetailParams): Promise<PlaceDetailsResponse> => {
    const result = await axios.get<PlaceDetailsResponse>('/api/places/detail', {
        params: {
            placeId,
            sessionToken,
            language: getLanguageFromLocale(locale),
        },
    });

    return result.data;
};

export { fetchPlacesDetail, fetchPlacesSuggestions };
